import React, { ReactNode } from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';

export interface StudyFormatBlockProps {
  title: ReactNode | SerializedEditorState;
  subtitle: ReactNode | SerializedEditorState;
  txtContent: ReactNode | SerializedEditorState;
  index: number;
  color: 'violet' | 'green' | 'blue';
}
export default function StudyFormatCardViolet({
  title,
  subtitle,
  txtContent,
  index,
  color,
}: StudyFormatBlockProps) {
  return (
    <div
      data-meta="StudyFormatCardViolet"
      className={`text-white ${
        index === 2 || index === 3 ? `file-violet-lg` : 'file-border-violet-lg'
      } w-[400px] h-[500px]`}
    >
      <div className={`px-8 pt-4 "pb-16"`}>
        <div className={`pb-4 border-b border-violet-300 mb-2`}>
          <CustomRichText data={title} tag="div" className="text-xl font-bold" />
          <CustomRichText data={subtitle} tag="div" className="text-xs" />
        </div>
        <CustomRichText data={txtContent} tag="div" className="text-sm" />
      </div>
    </div>
  );
}
